import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSidebarOpen: false,
};
export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    closeSidebar: (state) => {
      state.isSidebarOpen = false;
    },
    openSidebar: (state) => {
      state.isSidebarOpen = true;
    },
  },
});

export const { closeSidebar, openSidebar } = sidebarSlice.actions;

export default sidebarSlice.reducer;
